export default __webpack_public_path__ + "static/media/qrcode.9772b2c1.svg";